// Messages type
export const LOCALSTORAGE_MESSAGE_KEY = 'snackbar_message_key';
export const SUCCESS_MESSAGE_TYPE = 'success';
export const ERROR_MESSAGE_TYPE = 'error';
export const INFO_MESSAGE_TYPE = 'info';
export const WARNING_MESSAGE_TYPE = 'warning';
export const LOCALSTORAGE_THEME_KEY = 'site_theme';
export const LOCALSTORAGE_COOKIE_CONSENT_KEY = 'resume_builder_cookie_consent';
export const LOCALSTORAGE_COOKIE_CONSENT_VALUE = 'seen';
